export const CONFIGURE_FEED_URL =
  'https://learn.headliner.app/hc/en-us/articles/25535560006679-How-to-show-your-email-address-on-your-RSS-feed';
